import styled from "styled-components";


export const ChallengeRootDiv = styled.div`
    width: 100%;
    border: ${(props) => (props.specialChallengeCard ? "1px solid #574426"  : "1px solid #1E3964")} ;
    height: ${(props) => (props.specialChallengeCard ? "7.125rem"  : "6.25rem")} ;
    border-radius: 0.5rem;
    background: ${(props) => (props.specialChallengeCard ? "#4C3512"  : "#E7EBEF")};
    display: flex;

`

export const ChallgeDetailsDiv = styled.div`
    width: 73%;
    display: flex;
    flex-direction: column;
    padding-left: 1rem;
    justify-content: space-evenly;

`

export const ChallengeRewardDiv = styled.div`
    width: 27%;
    background: ${(props) => (props?.specialChallengeCard === true ? "radial-gradient(80.99% 62.1% at 50% 14.51%, rgba(229, 156, 34, 0.54) 0%, rgba(141, 87, 0, 0.54) 41.1%, rgba(70, 39, 0, 0.54) 96.56%)":"#1E3964")};
    border-radius: 0px 6px 6px 0px;
    display: flex;
    position:  ${(props) => (props?.specialChallengeCard === true && "relative")};
    flex-direction: column;
    /* justify-content: space-around; */
    gap: 0.25rem;
    align-items: center;
`

export const BlueBoxDiv = styled.div`
    background: ${(props) => (props?.bgColor)};
    padding : 2px 6px 2px 6px;
    color: ${(props) => (props.color)} ;
    font-weight: ${(props) => (props.fWeight)};
    font-size: 0.625rem;
    /* margin-left: 1rem; */
    border-radius: 4px;

`


export const ChallengeNameDiv = styled.div`
    font-weight: 700;
    font-size: 0.813rem;
    color: ${(props) => (props.specialChallengeCard ? "#E7EBEF"  : "#032146")};
    /* margin-left: 1rem; */
    /* margin-top: 0.5rem; */

`

export const ChallengeTypeAndDate = styled.div`
    display: flex;
    width: 100%;
    gap: 0.5rem;
    /* margin-left: 1rem; */
    /* margin-top: 0.5rem; */
    /* justify-content: space-evenly; */

`

export const ChallengeDescriptionDiv = styled.div`
    font-weight: 700;
    font-size: 0.75rem;
    color: ${(props) => (props.color)};
`



export const ProgressTextDiv = styled.div`
    font-weight: 500;
    font-size: .625rem;
    color: ${(props) => (props.specialChallengeCard ? "#F1F1F3" : " #223655")};
    margin-left: 0.5rem;


`


export const ChallengeProgressbarDiv = styled.div`
  display: flex;
  height: 0.375rem;
  align-items: center;
  width: 100%;
  border-radius: 8px;
`;

export const ChallengeProgressBar = styled.div`
  width: 40%;
  display: flex;
  height: 0.375rem;
  padding-right: 0px;
  align-items: center;
  border: ${(props) => ((props.shouldShade === true || props.specialChallengeCard === true ) ? '' : '1px solid #075063')};
  box-shadow: 0px 0.5px 1px 0px #9ec3d840;
  box-shadow: 0px 1px 3px 0px #00000021 inset;
  border-radius: 8px;
  background: ${(props) =>
    props.shouldShade === true
      ? '#707070'
      : props.isFromBundle === true
      ? '#080D1A' :
      props.specialChallengeCard === true 
      ? "rgba(0, 0, 0, 1)"
      : '#1E3964'}; // rgba(25, 106, 41, 0.25);
  /* background: ${(props) => (props.shouldShade === true ? '#707070' : '#42BE40')};  */
  /* box-shadow:${(props) => ((props.specialChallengeCard === true ) ? '0px 1px 3px 0px #00000021 inset' : '0px 1px 1px rgba(158, 195, 216, 0.25)')}  */
  
`;

export const ChallengeProgressBarFilled = styled.div`
  height: 0.25rem;
  border-radius: 8px 8px 8px 8px;
  background: ${(props) => (props.shouldShade === true ? '#BABABA' : '#42BE40')}; //#196A29;
  width: ${(props) => (props.fillArea ? props.fillArea : '10%')};
  /* ${(props) => (props.isSelected ? '0.1875rem solid #032146' : '')}; */
`;

export const ChallengeRewardAmount = styled.div`
    width: 100%;
    display: flex;
    color: ${(props) => (props?.specialChallengeCard === true ? "#0000": "#EABF69")} ;
    background:  ${(props) => (props?.specialChallengeCard === true && "linear-gradient(-3deg, #ffb834, #e6c683)")};
    font-size: 1.125rem;
    font-weight: 700;
    -webkit-background-clip: text;
    justify-content: center;
    background-clip: text;
    align-items: center;
    font-family: 'Conto';
`

